export default __webpack_public_path__ + "static/media/iconZoomOut.6007330e.svg";